import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Bar } from "react-chartjs-2";
import DOMPurify from "dompurify";
import * as XLSX from "xlsx";
import html2canvas from "html2canvas";
import { Pie } from "react-chartjs-2";
import styles from "../../ReportDetail.module.css"; // Import the CSS module
import ChartDataLabels from "chartjs-plugin-datalabels"; // Import the plugin

import { Bubble } from "react-chartjs-2";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  ArcElement,
  Legend,
} from "chart.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleCheck,
  fas,
  faChartBar,
} from "@fortawesome/free-solid-svg-icons";
// import RelevantReports from "../reportType/RelevantReports";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import axiosClient from "../../axios-client";
import MarketCards from "./marketCard";
import MarketScope from "./marketScope";
import GlobalDataSummary from "./globalDataSummary";
import GlobalPieChart from "../reportType/globalPieChart";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels,
  ArcElement
);

function ReportDetail() {
  const { state: report } = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [companies, setCompanies] = useState([]); // State for companies data
  const [currentPage, setCurrentPage] = useState(1);
  const companiesPerPage = 10; // 8 companies per page

  const [countries, setCountries] = useState([]);
  const [regions, setRegions] = useState([]);
  const [dataregions, setdataRegions] = useState([]);
  const [segments, setSegments] = useState([]);
  const [chartData, setChartData] = useState(null);
  const [firstYear, setfirstYear] = useState("");
  const [lastYear, setlastYear] = useState("");
  const [uniqueNamesArray, setUniqueNamesArray] = useState([]);
  const [SegmentsWithSubSegments, setSegmentsWithSubSegments] = useState([]);
  const [regionTotals, setRegionTotals] = useState([]);
  const [regionalsummery, setregionalsummery] = useState([]);
  const [countryYearSums, setCountryYearSums] = useState([]);
  const [activeSection, setActiveSection] = useState("overview"); // Manage active section state
  const [regionYearlyData, setRegionYearlyData] = useState([]);
  const [firstyearSEGTotalValues, setfirstyearSEGTotalValues] = useState({});
  const [lastyearSEGTotalValues, setlastyearSEGTotalValues] = useState({});
  const [aggregatedYearlyData, setAggregatedYearlyData] = useState({});
  const [yearlyprocessed, setyearlyprocessed] = useState({});
  const [FirstYearData, setFirstYearData] = useState({});
  const [LastYearData, setLastYearData] = useState({});

  //company ids
  const [companyIds, setCompanyIds] = useState([]); // Store company IDs
  const [isFreeUser, setIsFreeUser] = useState(false);
  const userID = localStorage.getItem("userID");
  const [user, setUser] = useState(null); // Assuming you have a way to get the logged-in user
  const [subscriptions, setSubscriptions] = useState([]);
  const status = localStorage.getItem("userStatus");
  const token = localStorage.getItem("token");

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const fetchSubscriptions = async () => {
    try {
      const response = await axiosClient.get(
        `/subscriptions/getSubscriptionsByUser/${userID}`
      );
      setSubscriptions(response.data);
    } catch (error) {
      console.error("Error fetching subscriptions:", error);
    }
  };
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setIsFreeUser(true);
    } else {
      fetchSubscriptions();
    }
  }, [user]);

  const handleButtonClick = (section) => {
    setActiveSection(section);
  };
  console.log(report);

  useEffect(() => {
    const userStatus = localStorage.getItem("userStatus");
    if (userStatus === "free" || userStatus === null) {
      setIsFreeUser(true);
    }
  }, []);

  /////////////region segment list
  useEffect(() => {
    if (report?.regions) {
      setdataRegions(report.regions);
      // console.log("regiondata", dataregions);
      const countriesList = report.regions.map((region) => region.country);

      const regionsList = [
        ...new Set(report.regions.map((region) => region.region)),
      ];
      setRegions(regionsList);
      setCountries(countriesList);

      setSegments(report.segments);

      // Object to group sub-segments by their parent segment
      const segmentsWithSubSegments = {};

      // Iterate through report.segments to extract segments and sub-segments
      // report?.segments?.forEach((segment) => {
      //   segment?.segments?.forEach((subSegment) => {
      //     const segmentName = subSegment.name;

      //     if (!segmentsWithSubSegments[segmentName]) {
      //       segmentsWithSubSegments[segmentName] = new Set();
      //     }

      //     // Add unique sub-segment names to the Set
      //     subSegment.subSegments.forEach((sub) => {
      //       segmentsWithSubSegments[segmentName].add(sub.name);
      //     });
      //   });
      // });

      // Convert Sets to arrays for rendering
      const segmentsWithSubSegmentsArray = {};
      for (const [key, value] of Object.entries(segmentsWithSubSegments)) {
        segmentsWithSubSegmentsArray[key] = Array.from(value);
      }

      // Set the cleaned object in state
      setSegmentsWithSubSegments(segmentsWithSubSegmentsArray);

      // Create a unique names array
      const uniqueNamesArray = Object.keys(segmentsWithSubSegmentsArray);
      setUniqueNamesArray(uniqueNamesArray);
      // console.log("dgd", uniqueNamesArray, SegmentsWithSubSegments);
    }
  }, [report]);

  const handleSubSegmentClick = (subSegment) => {
    console.log(`You clicked on: ${subSegment}`);
    // Add your custom logic here, e.g., navigate, fetch data, or update state
  };
  // first year segments data calculation/
  useEffect(() => {
    if (report?.segments) {
      const processedData = report?.segments?.map((segmentData) => {
        const country = segmentData?.country;
        const segmentDetails = segmentData?.segments?.map((segment) => {
          const segmentName = segment.name;
          const subSegmentDetails = segment?.subSegments?.map((subSegment) => {
            const subSegmentName = subSegment?.name;
            const firstYearValue = subSegment?.years[0]?.value || 0;

            return {
              subSegmentName,
              firstYearValue,
            };
          });

          // Calculate sum of all first year values for the subsegments
          const firstYearTotal = subSegmentDetails.reduce(
            (sum, subSegment) => sum + subSegment.firstYearValue,
            0
          );

          return {
            segmentName,
            subSegmentDetails,
            firstYearTotal,
          };
        });

        return {
          country,
          segmentDetails,
        };
      });

      setfirstyearSEGTotalValues(processedData);
      // console.log("uiewyghd", firstyearSEGTotalValues);
    }
  }, [report]);

  // last  year segments data calculation/

  useEffect(() => {
    if (report?.segments) {
      const processedData = report.segments.map((segmentData) => {
        const country = segmentData.country;
        const segmentDetails = segmentData.segments.map((segment) => {
          const segmentName = segment.name;
          const subSegmentDetails = segment.subSegments.map((subSegment) => {
            const subSegmentName = subSegment.name;

            // Get the value of the last year (the last item in the 'years' array)
            const lastYearValue =
              subSegment.years.length > 0
                ? subSegment.years[subSegment.years.length - 1].value
                : 0;

            return {
              subSegmentName,
              lastYearValue,
            };
          });

          // Calculate sum of all last year values for the subsegments
          const lastYearTotal = subSegmentDetails.reduce(
            (sum, subSegment) => sum + subSegment.lastYearValue,
            0
          );

          return {
            segmentName,
            subSegmentDetails,
            lastYearTotal,
          };
        });

        return {
          country,
          segmentDetails,
        };
      });

      setlastyearSEGTotalValues(processedData);
      // console.log(processedData);
    }
  }, [report]);

  ///////
  // all year segment year calculation
  useEffect(() => {
    if (report?.segments) {
      // Process data for each country, but only for the first segment
      const processedData = report.segments
        .map((segmentData) => {
          const country = segmentData.country;

          // Focus on the first segment only
          const firstSegment = segmentData.segments[0];
          if (!firstSegment) return null;
          const segmentName = firstSegment.name;
          const subSegmentDetails = firstSegment.subSegments.map(
            (subSegment) => {
              const subSegmentName = subSegment.name;

              // Get the value for each year
              const yearlyData = subSegment.years.map((yearData) => ({
                year: yearData.year,
                value: yearData.value || 0,
              }));

              return {
                subSegmentName,
                yearlyData,
              };
            }
          );

          return {
            country,
            segmentName,
            subSegmentDetails,
          };
        })
        .filter(Boolean); // Filter out null values

      // Sum the sub-segment values across all countries and years for the first segment only
      const yearSubSegmentTotals = {};

      report.segments.forEach((segmentData) => {
        const firstSegment = segmentData.segments[0];
        if (!firstSegment) return; // Skip if no first segment exists

        firstSegment.subSegments.forEach((subSegment) => {
          subSegment.years.forEach((yearData) => {
            const { year, value } = yearData;
            const subSegmentName = subSegment.name;

            if (!yearSubSegmentTotals[subSegmentName]) {
              yearSubSegmentTotals[subSegmentName] = {};
            }

            if (!yearSubSegmentTotals[subSegmentName][year]) {
              yearSubSegmentTotals[subSegmentName][year] = 0;
            }

            // Accumulate the total value for the specific sub-segment and year
            yearSubSegmentTotals[subSegmentName][year] += value;
          });
        });
      });

      // Extract first year and last year data for the first segment
      const firstYearData = {};
      const lastYearData = {};

      Object.entries(yearSubSegmentTotals).forEach(
        ([subSegmentName, yearlyTotals]) => {
          const years = Object.keys(yearlyTotals).map(Number); // Convert year keys to numbers
          const firstYear = Math.min(...years); // Get the first year
          const lastYear = Math.max(...years); // Get the last year

          firstYearData[subSegmentName] = yearlyTotals[firstYear] || 0;
          lastYearData[subSegmentName] = yearlyTotals[lastYear] || 0;
        }
      );

      // Set the state with the processed data
      setyearlyprocessed(processedData);
      setAggregatedYearlyData(yearSubSegmentTotals);

      // Store first year and last year totals in state
      setFirstYearData(firstYearData);
      setLastYearData(lastYearData);
      console.log(processedData);
    }
  }, [report]);

  // Convert FirstYearData into labels and values
  const labels = Object.keys(FirstYearData); // Sub-segment names
  const values = Object.values(FirstYearData); // Corresponding values

  // Define the data for the pie chart
  const segfirstdata = {
    labels: labels, // Chart labels
    datasets: [
      {
        label: "First Year Data",
        data: values, // Values for the chart
        backgroundColor: [
          "#B042AA", // Colors for each slice
          "#ED7845",
          "#889CEC",
          "#DD517C",
          "#D2D5DA",
        ],
        borderWidth: 1, // Border width of slices
      },
    ],
  };

  // Pie chart options (optional)
  const segfirstoptions = {
    plugins: {
      legend: {
        position: "bottom", // Position the legend at the bottom
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const value = context.raw;
            return `${context.label}: ${value.toFixed(2)}`; // Display values with two decimal points
          },
        },
      },
    },
  };

  const lastlabels = Object.keys(LastYearData); // Sub-segment names
  const lastvalues = Object.values(LastYearData); // Corresponding values

  // Define the data for the pie chart
  const seglastdata = {
    labels: lastlabels, // Chart labels
    datasets: [
      {
        label: "First Year Data",
        data: lastvalues, // Values for the chart
        backgroundColor: [
          "#B042AA", // Colors for each slice
          "#ED7845",
          "#889CEC",
          "#DD517C",
          "#D2D5DA",
        ],
        borderWidth: 1, // Border width of slices
      },
    ],
  };

  // Pie chart options (optional)
  const seglastoptions = {
    plugins: {
      legend: {
        position: "bottom", // Position the legend at the bottom
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const value = context.raw;
            return `${context.label}: ${value.toFixed(2)}`; // Display values with two decimal points
          },
        },
      },
    },
  };
  ////

  useEffect(() => {
    if (report?.regions) {
      // Function to calculate the summed values by region and year
      const calculateRegionSums = () => {
        const regionDataMap = {};

        report.regions.forEach((region) => {
          region.years.forEach((yearObj) => {
            const key = `${region.region}-${yearObj.year}`; // Unique key for each region and year

            if (!regionDataMap[key]) {
              // Initialize region-year data if not already present
              regionDataMap[key] = {
                region: region.region,
                year: yearObj.year,
                value: 0,
              };
            }

            // Add the country's year's value to the corresponding region-year total
            regionDataMap[key].value += yearObj.value;
          });
        });

        // Convert the map to an array of region totals
        const calculatedTotals = Object.values(regionDataMap);
        setRegionTotals(calculatedTotals); // Store the calculated totals in state
      };

      calculateRegionSums();
    }
  }, [report]);
  const years = Array.from(new Set(regionTotals.map((item) => item.year)));
  const getRegionData = (region, year) => {
    const data = regionTotals.filter(
      (item) => item.region === region && item.year === year
    );
    const value = data.length ? data[0].value : 0;

    return value.toFixed(1); // Or use 2 for 2 decimal places
  };
  const calculateCAGR = (startValue, endValue, years) => {
    const growthRate = (endValue / startValue) ** (1 / years) - 1;
    return (growthRate * 100).toFixed(2) + "%";
  };
  // console.log("uwei", years);
  ///////
  useEffect(() => {
    if (report?.regions) {
      // Function to calculate the summed values by region
      const calculateRegionSums = () => {
        const regionSummaries = {}; // Renamed variable

        report.regions.forEach((regionItem) => {
          if (!regionSummaries[regionItem.region]) {
            regionSummaries[regionItem.region] = {
              regionName: regionItem.region,
              totalValue: 0,
            };
          }

          // Sum values for all years within the region
          regionItem.years.forEach((yearData) => {
            // Renamed 'yearObj' to 'yearData'
            regionSummaries[regionItem.region].totalValue += yearData.value;
          });
        });

        // Convert the map to an array of region totals
        const regionTotalsArray = Object.values(regionSummaries); // Renamed 'calculatedTotals' to 'regionTotalsArray'
        setregionalsummery(regionTotalsArray); // Store the calculated totals in state
      };

      calculateRegionSums();
    }
  }, [report]);

  // console.log(regionalsummery); // This will now log the region total sums

  const regionalsumm = {
    datasets: [
      {
        label: "Total Value by Region", // Dataset label
        data: regionalsummery.map((item, index) => ({
          x: item.totalValue, // Total Value for x-axis
          y: index, // Index of the region for y-axis (can also use any other metric)
          r: Math.sqrt(item.totalValue) * 0.1, // Calculate radius, scaled for visibility
        })),
        backgroundColor: "#923351", // Bubble color
        borderColor: "#ffffff",
        hoverBackgroundColor: "#FF5733",
        hoverBorderColor: "#FF5733",
      },
    ],
  };

  const regionaloptions = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: "Total Value by Region (Bubble Chart)",
      },
      datalabels: {
        display: false, // Disable data labels
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const { x, y, r } = context.raw;
            return `Total Value: ${x} - Radius: ${r}`;
          },
        },
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        title: {
          display: true,
          text: "Total Value",
        },
        grid: {
          display: false, // Hide horizontal grid lines (optional)
        },
      },
      y: {
        ticks: {
          callback: function (value, index, values) {
            return regionalsummery[value]?.regionName || ""; // Display region names on the y-axis
          },
        },
        title: {
          display: true,
          text: "Region",
        },
      },
    },
  };

  ///////////FOR TITLE

  useEffect(() => {
    if (report?.Title_year) {
      const years = report.Title_year.map((item) => item.year);
      const values = report.Title_year.map((item) => item.value);
      setfirstYear(report.Title_year[0]?.year || 0); // First year value
      setlastYear(report.Title_year[report.Title_year.length - 1]?.year || 0);
      // console.log("first", firstYearValue, "last", lastYearValue);

      // console.log("year", years, "value", values);
      setChartData({
        labels: years, // X-axis labels
        datasets: [
          {
            label: "Value",
            data: values, // Y-axis data
            backgroundColor: "rgba(146, 51, 81, 1)", // Bar colors
            borderColor: "rgba(75, 192, 192, 1)",
            borderWidth: 1,
            borderRadius: 5,
            datalabels: {
              display: true,
              align: "end",
              anchor: "end",
              formatter: (value) => `$${value.toFixed(2)}`,
            },
          },
        ],
      });
    }
  }, [report]);

  /////////////////FOR calaculating  THE SUM OF ALL REGION

  useEffect(() => {
    if (report?.regions) {
      const calculateRegionSums = () => {
        const regionDataMap = {};

        report?.regions?.forEach((region) => {
          region?.years?.forEach((yearObj) => {
            const key = `${region.region}-${yearObj.year}`;

            if (!regionDataMap[key]) {
              regionDataMap[key] = {
                region: region.region,
                year: yearObj.year,
                value: 0,
              };
            }
            regionDataMap[key].value += yearObj.value;
          });
        });
      };
      calculateRegionSums();
    }
  }, [report]);

  // Generate chart data
  const generateChartData = () => {
    const years = [...new Set(regionTotals?.map((data) => data.year))];
    const regions = [...new Set(regionTotals?.map((data) => data.region))];
    const colors = ["#B84167", "#E0C8D1", "#DD517C", "#923351", "#431726"];
    const datasets = regions?.map((region, index) => {
      return {
        label: region,
        data: years.map(
          (year) =>
            regionTotals.find(
              (data) => data.year === year && data.region === region
            )?.value || 0
        ),
        datalabels: {
          display: false, // Disable data labels
        },
        backgroundColor: colors[index % colors.length],
      };
    });
    return {
      labels: years,
      datasets,
    };
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true, // Show legend for regions
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Year", // Label for X-axis
        },
        ticks: {
          autoSkip: false, // Ensure all labels are shown
          maxRotation: 0, // Keep text horizontal
          minRotation: 0,
        },
      },
      y: {
        title: {
          display: true,
          text: "Value", // Label for Y-axis
        },
        beginAtZero: true,
      },
    },
  };

  // const chartOptions = {
  //   responsive: true,
  //   plugins: {
  //     legend: {
  //       position: "top",
  //     },
  //     title: {
  //       display: true,
  //       text: report?.reportTitle,
  //     },
  //   },
  //   scales: {
  //     x: {
  //       stacked: true,
  //       display: false,
  //     },
  //     y: {
  //       stacked: true,
  //     },
  //   },
  //   layout: {
  //     padding: {
  //       bottom: 30, // Adds space between the chart and the legend (you can adjust this value)
  //     },
  //   },
  // };

  /////////////////

  useEffect(() => {
    if (report?.segments) {
      const segmentData = report.segments.map((segment) => ({
        name: segment.segmentName,
        subSegments: segment.subSegments || [],
      }));
      setSegments(segmentData);
    }
  }, [report]);
  ////////country year sum
  // useEffect(() => {
  //   if (report?.regions) {
  //     const calculateCountryYearlyTotals = () => {
  //       const totals = report.regions.map((region) => {
  //         const totalValue = region.years.reduce((sum, yearObj) => {
  //           return sum + (yearObj.value || 0); // Sum up all year values
  //         }, 0);

  //         return {
  //           country: region.country,
  //           totalValue, // Store the calculated total
  //         };
  //       });
  //       const sortedData = totals.sort((a, b) => b.totalValue - a.totalValue);

  //       setCountryYearSums(sortedData);
  //     };

  //     calculateCountryYearlyTotals();
  //   }
  //   // console.lsog("dfgdjk231", countryYearSums);
  // }, [report]);

  useEffect(() => {
    if (report?.regions) {
      const calculateCountryYearlyTotals = () => {
        const currentYear = new Date().getFullYear(); // Get the current year

        const totals = report.regions.map((region) => {
          const totalValue = region.years
            .filter((yearObj) => yearObj.year === currentYear) // Filter only current year
            .reduce((sum, yearObj) => sum + (yearObj.value || 0), 0);

          return {
            country: region.country,
            totalValue, // Store the calculated total for the current year
          };
        });

        const sortedData = totals.sort((a, b) => b.totalValue - a.totalValue);
        setCountryYearSums(sortedData);
      };

      calculateCountryYearlyTotals();
    }
  }, [report]);

  const top10CountryYearSums = countryYearSums
    .sort((a, b) => b.totalValue - a.totalValue) // Sort in descending order
    .slice(0, 10); // Get top 10 values

  const countrychartData = {
    labels: top10CountryYearSums.map((data) => data.country), // List of top 10 country names
    datasets: [
      {
        label: "Total Value (Sum of Years)",
        data: top10CountryYearSums.map((data) => data.totalValue.toFixed(2)), // List of total values for top 10 countries
        backgroundColor: "#923351", // Customize the color
        borderColor: "#923351", // Customize the border color
        borderWidth: 1,
        // Set bar thickness and spacing
        barPercentage: 0.1, // Space between bars
        categoryPercentage: 5, // Space between groups of bars (category)
      },
    ],
  };
  // const countrychartData = {
  //   labels: countryYearSums.map((data) => data.country), // List of country names
  //   datasets: [
  //     {
  //       label: "Total Value (Sum of Years)",
  //       data: countryYearSums.map((data) => data.totalValue.toFixed(2)), // List of total values for each country
  //       backgroundColor: "#923351", // Customize the color
  //       borderColor: "#923351", // Customize the border color
  //       borderWidth: 1,
  //       // Set bar thickness and spacing
  //       barPercentage: 0.1, // Space between bars
  //       categoryPercentage: 5, // Space between groups of bars (category)
  //     },
  //   ],
  // };
  // Chart options
  const countryoptions = {
    responsive: true,
    maintainAspectRatio: false, // Disables aspect ratio, allowing custom height
    indexAxis: "y", // This makes the chart horizontal
    plugins: {
      title: {
        display: true,
        text: "Total Value per Country (Sum of All Years)",
      },
      // datalabels: {
      //   display: false, // Disable data labels
      // },
      tooltip: {
        callbacks: {
          label: (context) => {
            return `Total: ${context?.raw}`; // Showing formatted value in tooltip
          },
        },
      },
    },
    ChartDataLabels: {
      align: "end", // Position the label at the end of the bar
      anchor: "end", // Ensures the label is anchored to the end of the bar
      color: "white", // Set the label color
      font: {
        weight: "bold",
      },
      formatter: (value) => value.toFixed(2), // Format the number (you can change the format)
    },

    scales: {
      x: {
        title: {
          display: true,
          text: "Total Value",
        },
      },
      y: {
        title: {
          display: true,
          text: "Countries",
        },
        grid: {
          display: false, // Hide horizontal grid lines (optional)
        },
        // Adding space between bars by controlling the scale properties
        ticks: {
          autoSkip: false, // Ensure all countries are displayed even if there's space
        },
      },
    },
    elements: {
      bar: {
        // Adjust bar thickness to create space
        borderWidth: 2, // Add border to create space
      },
    },
    layout: {
      padding: {
        top: 0.1,
        bottom: 1.0,
      },
    },
    // Modify these values to add space between bars
    datasets: {
      bar: {
        categoryPercentage: 0.8, // Decrease the width of the category to add space between bars
        barPercentage: 0.9, // Slightly reduce the width of the bars
      },
    },
  };
  ////
  // data for Statistics
  useEffect(() => {
    if (report?.regions) {
      // Function to calculate region-wise yearly sum
      const calculateRegionYearlyData = () => {
        const regionData = report.regions.reduce((acc, region) => {
          const { region: regionName, years } = region;

          if (!acc[regionName]) {
            acc[regionName] = {}; // Initialize region object if not already present
          }

          years.forEach(({ year, value }) => {
            // Add the value for each year, summing up across countries
            acc[regionName][year] = (acc[regionName][year] || 0) + value;
          });

          return acc;
        }, {});

        // Convert the aggregated data into an array for rendering
        const formattedRegionData = Object.entries(regionData).map(
          ([region, yearlyData]) => ({
            region,
            yearlyData: Object.entries(yearlyData).map(([year, value]) => ({
              year: parseInt(year),
              value,
            })),
          })
        );

        setRegionYearlyData(formattedRegionData);
      };

      calculateRegionYearlyData();
      // console.log("fdhsj546", regionYearlyData);
    }
  }, [report]);

  ////////
  // company
  useEffect(() => {
    if (report && report.companies) {
      // Extract all unique company IDs from the report's companies array
      const ids = report.companies
        .map((company) => company.company)
        .filter((id, index, self) => self.indexOf(id) === index); // Get unique IDs
      setCompanyIds(ids);
    }
  }, [report]);

  useEffect(() => {
    if (companyIds.length > 0) {
      const fetchCompanies = async () => {
        try {
          const response = await axiosClient.post(
            "company/getcompany/byreport",
            {
              ids: companyIds,
            }
          );
          if (response.status === 200) {
            setLoading(false);
            setCompanies(response.data.companies);
            // console.log("server response com",response.data.companies)
          }
        } catch (error) {
          console.error("Error fetching companies:", error);
        }
      };
      fetchCompanies();
    }
  }, [companyIds]);

  const totalPages = Math.ceil(companies.length / companiesPerPage);

  // Get the index range of the companies to display on the current page
  const indexOfLastCompany = currentPage * companiesPerPage;
  const indexOfFirstCompany = indexOfLastCompany - companiesPerPage;
  const currentCompanies = companies.slice(
    indexOfFirstCompany,
    indexOfLastCompany
  );

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleNextClick = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handleBackClick = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  const handleCompanyClick = (company) => {
    navigate("/Company-details", { state: { company } });
    console.log(company);
  };

  const handleIndustryClick = (industry) => {
    console.log(`You clicked on industry: ${industry}`);
    // Add logic to navigate or fetch industry-specific data if needed
  };

  /////////
  const handleCountryClick = (selectedCountry) => {
    // Find the region data for the selected country
    const selectedRegion = report.regions.find(
      (region) => region.country === selectedCountry
    );

    if (selectedRegion) {
      // Extract the years and values data for the selected country
      const countryData = selectedRegion.years.map((yearData) => ({
        year: yearData.year,
        value: yearData.value,
      }));

      // Log the country data (CAGR, year data, and region)
      // console.log({
      //   country: selectedCountry,
      //   region: selectedRegion.region,
      //   cagr: selectedRegion.cagr,
      //   data: countryData,
      // });
      const dataToPass = {
        country: selectedCountry,
        region: selectedRegion.region,
        cagr: selectedRegion.cagr,
        data: countryData,
        reportName: report?.reportTitle,
      };

      // Use navigate to redirect to "/report-country" with the data
      navigate("/report-country", { state: { countryData: dataToPass } });
    }
  };
  const handleRegionClick = (selectedRegionName) => {
    // Find the region data for the selected region name
    const selectedRegion = report.regions.find(
      (region) => region.region === selectedRegionName
    );

    if (selectedRegion) {
      // Extract the years and values data for the selected region
      const regionData = selectedRegion.years.map((yearData) => ({
        year: yearData.year,
        value: yearData.value,
      }));

      // Log the region data (CAGR, year data, and countries)
      // console.log({
      //   region: selectedRegionName,
      //   // countries: selectedRegion.countries,
      //   cagr: selectedRegion.cagr,
      //   data: regionData,
      // });

      const dataToPass = {
        region: selectedRegionName,
        countries: selectedRegion.countries,
        cagr: selectedRegion.cagr,
        data: regionData,
        reportName: report?.reportName,
      };
      navigate("/report-region", { state: { regionData: dataToPass } });
    } else {
      console.error("Region not found in report data");
    }
  };

  ////////////////////////////////////////////download handler  for report from statistics///////////////
  const handleDownloadReport = () => {
    // Data for the first table (Statistics Table)
    const reportTitle = report?.reportTitle || "Comprehensive Report";

    const table1Data = [
      [reportTitle], // Title row
      ["Region", ...years, `CAGR (${years[0]}-${years[years.length - 1]})`],
      ...regions.map((region) => {
        const values = years.map((year) => getRegionData(region, year));
        const cagr = calculateCAGR(
          values[0],
          values[values.length - 1],
          years.length - 1
        );
        return [region, ...values, cagr];
      }),
      [
        "Total",
        ...years.map((year) => {
          const totalForYear = regions.reduce(
            (sum, region) => sum + parseFloat(getRegionData(region, year)),
            0
          );
          return totalForYear.toFixed(1);
        }),
        calculateCAGR(
          regions.reduce(
            (sum, region) => sum + parseFloat(getRegionData(region, years[0])),
            0
          ),
          regions.reduce(
            (sum, region) =>
              sum + parseFloat(getRegionData(region, years[years.length - 1])),
            0
          ),
          years.length - 1
        ),
      ],
    ];

    // Data for the second table (Report Table)
    const table2Data = [
      [reportTitle], // Title row
      [
        "Region",
        "Country",
        ...years,
        `CAGR (${years[0]}-${years[years.length - 1]})`,
      ],
      ...dataregions.map((regionData) => {
        const values = regionData.years.map((yearData) => yearData.value);
        const cagr = calculateCAGR(
          values[0],
          values[values.length - 1],
          values.length - 1
        );
        return [
          regionData.region,
          regionData.country,
          ...values.map((value) => value.toFixed(1)),
          cagr,
        ];
      }),
    ];

    // Create a new Excel workbook
    const workbook = XLSX.utils.book_new();

    // Add the first table's data as a worksheet
    const worksheet1 = XLSX.utils.aoa_to_sheet(table1Data);
    XLSX.utils.book_append_sheet(workbook, worksheet1, "Statistics");

    // Add the second table's data as a worksheet
    const worksheet2 = XLSX.utils.aoa_to_sheet(table2Data);
    XLSX.utils.book_append_sheet(workbook, worksheet2, "Report");

    // Apply styling for the report title
    const styleTitle = { font: { bold: true } };
    worksheet1["A1"].s = styleTitle;
    worksheet2["A1"].s = styleTitle;
    // Save the Excel file
    XLSX.writeFile(
      workbook,
      `${report?.reportTitle || "Report"}_Full_Report.xlsx`
    );
  };

  ////////////////////////////////////////////download handler  for report from graphs///////////////
  const downloadChartAsPNG = () => {
    const canvas = document.getElementById("chartCanvas");
    addDownloads();
    html2canvas(canvas).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.href = imgData;
      link.download = `${report?.reportTitle}}_chart.png`;
      link.click();
    });
  };
  const graphData = report?.Title_year;
  // Download data as Excel
  const downloadDataAsExcel = () => {
    const data = [
      ["Year", "Revenue"], // Header row
      ...graphData.map((item) => [item.year, item.value]), // Data rows
    ];
    addDownloads();
    const ws = XLSX.utils.aoa_to_sheet(data); // Create a worksheet
    const wb = XLSX.utils.book_new(); // Create a workbook
    XLSX.utils.book_append_sheet(wb, ws, "Revenue Data"); // Append sheet to workbook

    XLSX.writeFile(wb, `${report?.reportTitle}_data.xlsx`); // Export to Excel file
  };

  const global_lastYear_cagr = (report?.Title_year[9]?.cagr * 100).toFixed(0);
  const global_firstYear_cagr = report?.Title_year[0]?.cagr;
  const global_first_value = report?.Title_year[0].value?.toFixed(2);
  const global_last_value = report?.Title_year[9].value?.toFixed(2);
  const global_first_year = report?.Title_year[0].year;
  const global_last_year = report?.Title_year[9].year;
  const newData = {
    firstYear: global_first_year,
    firstValue: global_first_value,
    lastYear: global_last_year,
    lastValue: global_last_value,
    cagr_last: global_lastYear_cagr,
    cagr_first: global_firstYear_cagr,
  };

  const [userData, setUserData] = useState();
  useEffect(() => {
    const plansData = sessionStorage.getItem("plans");
    if (plansData) {
      const parsedData = JSON.parse(plansData);
      setUserData(parsedData);
    }
  }, []);

  const chartRef = useRef(null);
  const chartHorRef = useRef(null);
  const addDownloads = async () => {
    const subscriptionId = subscriptions[0]?._id;
    try {
      const response = await axiosClient.patch(
        `/subscriptions/update-plan/${subscriptionId}`
      );
      fetchSubscriptions();
    } catch (error) {
      console.log(error);
    }
  };
  const downloadChartPNG = () => {
    if (!chartRef.current) return;
    addDownloads();
    html2canvas(chartRef.current, { scale: 2 }).then((canvas) => {
      const link = document.createElement("a");
      link.href = canvas.toDataURL("image/png");
      link.download = `${report?.reportTitle || "chart"}.png`;
      link.click();
    });
  };
  const downloadChartHoriPNG = () => {
    if (!chartHorRef.current) return;
    addDownloads();
    html2canvas(chartHorRef.current, { scale: 2 }).then((canvas) => {
      const link = document.createElement("a");
      link.href = canvas.toDataURL("image/png");
      link.download = `${report?.reportTitle || "chart"}.png`;
      link.click();
    });
  };
  return (
    <div
      className=" min-h-screen p-6"
      style={{ maxWidth: "91rem", backgroundColor: "#F0F9FF" }}
    >
      <div className="max-w-6xl mx-auto" style={{ maxWidth: "91rem" }}>
        <h1 className="text-3xl font-bold text-gray-800 mb-4">
          {`${report?.reportTitle} Market Size Study & Forecast Outlook, ${
            report?.Title_year[0]?.year
          }-${
            report?.Title_year[report?.Title_year?.length - 1]?.year
          } (US$M)` || "No Name"}
        </h1>
        <p className="text-gray-600 mb-8">
          {report?.summary
            ? report.summary.split(" ").slice(0, 50).join(" ") +
              (report.summary.split(" ").length > 50 ? "..." : "")
            : "Detailed description of the report"}
        </p>
      </div>
      {/* Key Metrics Section */}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-6">
        <div className="bg-white rounded shadow p-4 text-center">
          <h3 className="text-gray-800 font-semibold">Revenue, {firstYear}</h3>
          <p className="text-xl font-bold text-green-600">
            ${report?.Title_year[0].value?.toFixed(2)}
          </p>
        </div>
        <div className="bg-white rounded shadow p-4 text-center">
          <h3 className="text-gray-800 font-semibold">Forecast, {lastYear}</h3>
          <p className="text-xl font-bold text-blue-600">
            $ {report?.Title_year[9]?.value?.toFixed(2)}
          </p>
        </div>
        <div className="bg-white rounded shadow p-4 text-center">
          <h3 className="text-gray-800 font-semibold">
            CAGR, {firstYear}- {lastYear}
          </h3>
          <p className="text-xl font-bold text-purple-600">
            {report?.Title_year[9]?.cagr &&
              `${(report.Title_year[9].cagr * 100).toFixed(2)}%`}
          </p>
        </div>
        <div className="bg-white rounded shadow p-4 text-center">
          <h3 className="text-gray-800 font-semibold">Region</h3>
          <p className="text-xl font-bold text-yellow-600">
            {report?.region || "Worldwide"}
          </p>
        </div>
      </div>

      <div className="flex px-4 py-2 rounded-md">
        <button
          onClick={() => handleButtonClick("overview")}
          className={`mr-3 font-medium ${
            activeSection === "overview"
              ? "text-pink-500"
              : "text-gray-700 hover:underline"
          }`}
        >
          Overview
        </button>
        {/* <button
          onClick={() => handleButtonClick("statistics")}
          className={`mr-3 font-medium ${
            activeSection === "statistics"
              ? "text-pink-500"
              : "text-gray-700 hover:underline"
          }`}
        >
          Statistics
        </button> */}
        <button
          onClick={() => handleButtonClick("companies")}
          className={`mr-3 font-medium ${
            activeSection === "companies"
              ? "text-pink-500"
              : "text-gray-700 hover:underline"
          }`}
        >
          Companies
        </button>
      </div>
      <hr />
      <br />

      {/* Overview and Chart Section */}
      {activeSection === "overview" && (
        <div>
          <div
            style={{ display: "flex", gap: "10px", alignItems: "flex-start" }}
          >
            <div className="bg-white rounded shadow p-6 mb-6 w-3/4">
              {/* Placeholder for chart */}
              <div
                className="relative  text-left"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                {" "}
                <h2 className="text-xl font-semibold text-gray-800 mb-4">
                  {report?.reportTitle?.replace(/\s*Size Study\s*/g, "").trim()}{" "}
                  {report?.Title_year?.[0]?.year} -{" "}
                  {report?.Title_year?.at(-1)?.year} (US$M)
                </h2>
                {userData?.features?.graphDownloadLimit >
                  subscriptions[0]?.downloads?.downloadGraphs && (
                  <button
                    className="bg-black text-white px-4 py-2 rounded inline-flex items-center"
                    style={{ fontSize: "12px" }}
                    onClick={() => setDropdownOpen(!dropdownOpen)}
                  >
                    Download Options
                    <svg
                      className="ml-2 w-4 h-4"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M5.23 7.21a.75.75 0 011.06.02L10 11.293l3.71-4.063a.75.75 0 111.08 1.04l-4.5 4.916a.75.75 0 01-1.08 0l-4.5-4.916a.75.75 0 01.02-1.06z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </button>
                )}
                {dropdownOpen && (
                  <div
                    className="absolute  mt-2 w-48 bg-white rounded-md shadow-lg z-10"
                    onMouseLeave={() => setDropdownOpen(false)}
                    style={{ top: 30, right: 0 }}
                  >
                    <div className="py-1">
                      <button
                        onClick={downloadChartAsPNG}
                        className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left"
                      >
                        Download PNG
                      </button>
                      <button
                        onClick={downloadDataAsExcel}
                        className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left"
                      >
                        Download Excel
                      </button>
                    </div>
                  </div>
                )}
              </div>
              <div className="w-3/3 h-70  rounded flex items-center ">
                {chartData ? (
                  <Bar
                    id="chartCanvas"
                    data={chartData}
                    options={{
                      responsive: true,
                      // plugins: {
                      //   // legend: {
                      //   //   position: "top",
                      //   // },
                      //   // title: {
                      //   //   display: true,
                      //   //   // text: "Yearly Values with CAGR",
                      //   // },
                      // },
                    }}
                  />
                ) : (
                  <p className="text-gray-500">No data available</p>
                )}
                <div
                  className="download-options text-right mt-6"
                  style={{ margintop: "-21.5rem" }}
                ></div>
                {/* <div className="mt-4 flex justify-end top-100"  style={{ margintop:"-20.5rem" }} >
                <button className="bg-black  text-white px-4 py-2 rounded shadow">
                  Download
                </button>
              </div> */}
              </div>
            </div>
            <div>
              <button
                onClick={() => navigate("/contact-us")}
                style={{ width: "100%", marginBottom: "13px" }}
                className="bg-black text-white py-3 px-4 rounded-lg mb-2 font-inter text-sm hover:bg-[#21242a]"
              >
                Purchase Comprehensive Report
              </button>
              <MarketCards report={report} />
            </div>
          </div>

          <div className="flex flex-col lg:flex-row gap-6 mb-6 items-start">
            {/* Report Summary Card */}
            <div className="bg-white rounded shadow p-6 flex-1 min-w-0">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">
                {report?.reportTitle}
              </h2>

              {/* Summary Description */}
              <div
                className="text-gray-600 mb-4 overflow-auto scrollbar-hide"
                style={{
                  maxHeight: "400px",
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                }}
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(
                    report?.summary || "Detailed description of the report"
                  ),
                }}
              />
            </div>

            {/* Bizwit at a Glance Section */}
            <div className="w-full lg:w-80 flex-shrink-0">
              <div className="bg-white rounded shadow p-6">
                <h2 className="text-2xl font-bold text-gray-800 mb-4 font-urban">
                  Bizwit at a Glance
                </h2>
                <ul className="list-none space-y-3">
                  <li className="flex items-center text-gray-600">
                    <FontAwesomeIcon
                      icon={faCircleCheck}
                      style={{ color: "#000000" }}
                      className="mr-2 flex-shrink-0"
                    />
                    <span>40K+ Comprehensive Market Reports</span>
                  </li>
                  <li className="flex items-center text-gray-600">
                    <FontAwesomeIcon
                      icon={faCircleCheck}
                      style={{ color: "#000000" }}
                      className="mr-2 flex-shrink-0"
                    />
                    <span>150K+ Country-Specific Reports</span>
                  </li>
                  <li className="flex items-center text-gray-600">
                    <FontAwesomeIcon
                      icon={faCircleCheck}
                      style={{ color: "#000000" }}
                      className="mr-2 flex-shrink-0"
                    />
                    <span>1.5M+ Market Data Points</span>
                  </li>
                  <li className="flex items-center text-gray-600">
                    <FontAwesomeIcon
                      icon={faCircleCheck}
                      style={{ color: "#000000" }}
                      className="mr-2 flex-shrink-0"
                    />
                    <span>250K+ Company Analyses</span>
                  </li>
                  <li className="flex items-center text-gray-600">
                    <FontAwesomeIcon
                      icon={faCircleCheck}
                      style={{ color: "#000000" }}
                      className="mr-2 flex-shrink-0"
                    />
                    <span>Deep Industry Expertise and Beyond</span>
                  </li>
                </ul>
                <button
                  onClick={() => navigate("/contact-us")}
                  className="mt-6 w-full bg-black text-white py-2.5 px-4 rounded-md hover:bg-gray-800 text-sm font-medium transition cursor-pointer"
                >
                  Ask a question
                </button>
              </div>
            </div>
          </div>

          <br />
          <GlobalDataSummary
            report={report}
            data={newData}
            uniqueNamesArray={uniqueNamesArray}
            firstYear={firstYear}
            lastYear={lastYear}
          />

          <br />
          {/* Market Scope Section */}
          <MarketScope report={report} />

          <div
            className="bg-white rounded shadow  p-6 w-3/4"
            style={{ width: "78.6rem" }}
          >
            <div className="flex justify-between">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">
                {report?.reportTitle} By Region (US$M)
              </h2>
              {userData?.features?.graphDownloadLimit >
                subscriptions[0]?.downloads?.downloadGraphs && (
                <button
                  onClick={downloadChartPNG}
                  className="bg-black text-white px-14 py-2 rounded-xl font-semibold hover:bg-[#21242a]"
                >
                  Download
                </button>
              )}
            </div>
            <div className={styles.chartContainer} ref={chartRef}>
              <div
                className={`${styles.chartWrapper} ${
                  !userData ? styles.blurred : ""
                }`}
                onClick={() => {
                  if (!userData) {
                    alert("Please subscribe to a plan to access this content.");
                    navigate("/pricing");
                  }
                }}
                style={{ cursor: !userData ? "pointer" : "default" }}
              >
                <div style={{ height: "500px" }}>
                  {regionTotals?.length > 0 && (
                    <Bar data={generateChartData()} options={chartOptions} />
                  )}
                </div>
                {!userData && (
                  <div className={styles.lockScreen} style={{ zIndex: 10 }}>
                    Locked Content
                  </div>
                )}
              </div>
            </div>
          </div>
          <br />
          {/* horizontal graph */}
          <div
            className="bg-white rounded shadow p-6  w-3/4"
            style={{ width: "78.6rem" }}
          >
            <div className="flex justify-between">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">
                {report?.reportTitle} By Region (US$M)
              </h2>
              {userData?.features?.graphDownloadLimit >
                subscriptions[0]?.downloads?.downloadGraphs && (
                <button
                  onClick={downloadChartHoriPNG}
                  className="bg-black text-white px-14 py-2 rounded-xl font-semibold hover:bg-[#21242a]"
                >
                  Download
                </button>
              )}
            </div>
            <div className={styles.chartContainer} ref={chartHorRef}>
              <div
                className={`${styles.chartWrapper} ${
                  !userData ? styles.blurred : ""
                }`}
                onClick={() => {
                  if (!userData) {
                    alert("Please subscribe to a plan to access this content.");
                    navigate("/pricing");
                  }
                }}
                style={{ cursor: !userData ? "pointer" : "default" }}
              >
                <div>
                  {regionTotals.length > 0 && (
                    <Bar
                      data={countrychartData}
                      options={countryoptions}
                      style={{ height: "1000px" }}
                    />
                  )}
                </div>
                {!userData && (
                  <div className={styles.lockScreen} style={{ zIndex: 10 }}>
                    Locked Content
                  </div>
                )}
              </div>
            </div>
          </div>
          <br />
          {/* Bubble Graph */}
          {/* <div
            className="bg-white rounded shadow p-6  w-3/4"
            style={{ width: "78.6rem" }}
          >
            <h2 className="text-xl font-semibold text-gray-800 mb-4">
              {report.reportTitle} ($ Million)
            </h2>
            <div className={styles.chartContainer}>
              <div
                className={`${styles.chartWrapper} ${
                  isFreeUser ? styles.blurred : ""
                }`}
              >
                <Bubble data={regionalsumm} options={regionaloptions} />
                {isFreeUser && (
                  <div className={styles.lockScreen} style={{ zIndex: 10 }}>
                    Locked Content
                  </div>
                )}
              </div>
            </div>
          </div> */}
          <br />
          <div className={styles.chartContainer}>
            <div
              className={`${styles.chartWrapper} ${
                !userData ? styles.blurred : ""
              }`}
              onClick={() => {
                if (!userData) {
                  alert("Please subscribe to a plan to access this content.");
                  navigate("/pricing");
                }
              }}
              style={{ cursor: !userData ? "pointer" : "default" }}
            >
              <GlobalPieChart segments={report} subscriptions={subscriptions} />

              <div className="h-full w-px bg-gray-300 mx-4"></div>
            </div>
          </div>
        </div>
      )}
      {activeSection === "statistics" && (
        <div>
          <div className="overflow-x-auto">
            <div className={styles.chartContainer}>
              <button
                onClick={handleDownloadReport}
                className="bg-black text-white px-4 py-2 rounded mb-4"
              >
                Download full comprehensive report
              </button>
              <div
                className={`${styles.chartWrapper} ${
                  isFreeUser ? styles.blurred : ""
                }`}
              >
                <table className="min-w-full table-auto font-inter">
                  <thead>
                    <tr className="bg-lightPink border-b text-sm">
                      <th className="px-4 py-4 text-left font-semibold">
                        Region
                      </th>
                      {years.map((year) => (
                        <th key={year} className="px-4 py-4 text-left">
                          {year}
                        </th>
                      ))}
                      <th className="px-4 py-4 text-left">
                        CAGR ({firstYear}-{lastYear})
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {regions.map((region) => {
                      const values = years.map((year) =>
                        getRegionData(region, year)
                      );
                      const cagr = calculateCAGR(values[2], values[10], 8);

                      return (
                        <tr key={region} className="border-b text-sm">
                          <td className="px-4 py-4 font-semibold">{region}</td>
                          {values.map((value, idx) => (
                            <td key={idx} className="px-4 py-4">
                              {value}
                            </td>
                          ))}
                          <td className="px-4 py-4 font-semibold">{cagr}</td>
                        </tr>
                      );
                    })}

                    {/* Total row */}
                    <tr className="font-semibold border-b text-sm">
                      <td className="px-4 py-4">Total</td>
                      {years.map((year, idx) => {
                        // Calculate total for each year
                        const totalForYear = regions.reduce(
                          (sum, region) =>
                            sum + parseFloat(getRegionData(region, year)),
                          0
                        );
                        return (
                          <td key={idx} className="px-4 py-4">
                            {totalForYear.toFixed(1)}{" "}
                            {/* Format to 1 decimal place */}
                          </td>
                        );
                      })}

                      {/* Calculate CAGR for the total sum */}
                      <td className="px-4 py-4 font-semibold">
                        {calculateCAGR(
                          regions.reduce(
                            (sum, region) =>
                              sum + parseFloat(getRegionData(region, years[0])),
                            0
                          ),
                          regions.reduce(
                            (sum, region) =>
                              sum +
                              parseFloat(
                                getRegionData(region, years[years.length - 1])
                              ),
                            0
                          ),
                          years.length - 1
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
                {isFreeUser && (
                  <div className={styles.lockScreen} style={{ zIndex: 10 }}>
                    Locked Content
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* New Table for dataRegions */}
          <div className="overflow-x-auto mt-8">
            <div className={styles.chartContainer}>
              <h1>report</h1>
              <div
                className={`${styles.chartWrapper} ${
                  isFreeUser ? styles.blurred : ""
                }`}
              >
                <table className="min-w-full table-auto font-inter">
                  <thead>
                    <tr className="bg-lightPink border-b text-sm">
                      <th className="px-4 py-4 text-left font-semibold">
                        Region
                      </th>
                      <th className="px-4 py-4 text-left font-semibold">
                        Country
                      </th>
                      {years.map((year) => (
                        <th key={year} className="px-4 py-4 text-left">
                          {year}
                        </th>
                      ))}
                      <th className="px-4 py-4 text-left">
                        CAGR ({firstYear}-{lastYear})
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {dataregions.map((regionData) => {
                      const values = regionData.years.map(
                        (yearData) => yearData.value
                      );
                      const cagr = calculateCAGR(
                        values[0],
                        values[values.length - 1],
                        values.length - 1
                      );

                      return (
                        <tr
                          key={regionData.country}
                          className="border-b text-sm"
                        >
                          <td className="px-4 py-4 font-semibold">
                            {regionData.region}
                          </td>
                          <td className="px-4 py-4 font-semibold">
                            {regionData.country}
                          </td>
                          {values.map((value, idx) => (
                            <td key={idx} className="px-4 py-4">
                              {value.toFixed(1)}
                            </td>
                          ))}
                          <td className="px-4 py-4 font-semibold">{cagr}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                {isFreeUser && (
                  <div className={styles.lockScreen} style={{ zIndex: 10 }}>
                    Locked Content
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {activeSection === "companies" && (
        <div>
          <div className="min-h-screen bg-blue-50">
            <div className="container mx-auto p-8">
              <div className="overflow-hidden rounded-lg border border-gray-300 bg-white">
                <div className="overflow-x-auto">
                  {loading ? (
                    <div className="text-center py-6">Loading companies...</div>
                  ) : (
                    <table className="min-w-full w-full table-auto">
                      <thead>
                        <tr className="text-left border-b border-gray-300">
                          <th className="py-3 px-2 sm:px-4">Companies</th>
                          <th className="py-3 px-2 sm:px-40 text-center sm:text-left">
                            HQ
                          </th>
                          <th className="py-3 px-0 sm:pr-14">
                            Employee Strength
                          </th>
                          <th className="py-3 px-2 sm:pl-2 sm:pr-60 text-left">
                            Market Relevance
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentCompanies?.map((company, index) => (
                          <tr key={index} className="border-b border-gray-300">
                            <td className="py-1 px-0 text-pink-500 text-center company2">
                              <button
                                onClick={() => handleCompanyClick(company)}
                                className="hover:underline bg-transparent border-none text-pink-500 cursor-pointer"
                              >
                                {company?.companyName}
                              </button>
                            </td>
                            <td className="py-3 px-16 company1">
                              {company?.headquarter}
                            </td>
                            <td className="py-1 px-6 pr-40 text-center company1">
                              {company?.employeeSize}
                            </td>
                            <td className="py-5 px-14">
                              {company?.marketRelevance}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
              </div>

              {/* Pagination Controls */}
              <div className="flex justify-end mt-6 space-x-2">
                <button
                  className="flex items-center px-2 py-1 bg-white border rounded"
                  onClick={handleBackClick}
                  disabled={currentPage === 1}
                >
                  <MdKeyboardArrowLeft className="mr-2" />
                  Back
                </button>
                {[...Array(totalPages)].map((_, index) => (
                  <button
                    key={index}
                    className={`px-3 py-1 border rounded ${
                      currentPage === index + 1
                        ? "bg-black text-white"
                        : "bg-white"
                    }`}
                    onClick={() => handlePageChange(index + 1)}
                  >
                    {index + 1}
                  </button>
                ))}
                <button
                  className="flex justify-between items-center px-3 py-1 bg-white border rounded"
                  onClick={handleNextClick}
                  disabled={currentPage === totalPages}
                >
                  <span>Next</span>
                  <MdKeyboardArrowRight className="ml-2" />
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ReportDetail;
